import { BaseModel } from '../base-model';

export interface IAppointmentOwner {
  IsPrivate?: boolean;
  OwnerId?: number;
  ShortName?: string
}
export class AppointmentOwner extends BaseModel<IAppointmentOwner> implements IAppointmentOwner {
  constructor(options?: IAppointmentOwner) {
    super(options);
  }
}